<template>
    <div>
        <!-- Display assets based on the selected month and theme -->
        <v-container fluid>
            <v-row>
                <v-col v-for="(magnet, index) in magnets" :key="index" cols="12" md="4">
                    <v-card @click="openDesign(magnet.url)" class="mx-auto" outlined>
                        <!-- Display the thumbnail if available, otherwise display an icon -->
                        <v-img :src="magnet.thumbnail" cover></v-img>
                        <v-card-title class="d-flex justify-space-between">
                            {{ magnet.title }}
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        
    </div>
  </template>
  
  <script>
    import magnets from '@/assets/lead-magnets.js'  // Import the content data

    export default {
        name: 'LeadMagnets',
        data: () => ({
            selectedTab: 2,
            magnets, 
            previousMonth: '',
            currentMonth: '',
            nextMonth: '',
            daysUntil20th: 0,
        }),
        methods: {
            // Open the design in a new tab when a card is clicked
            openDesign(url) {
                window.open(url, '_blank');
            },
        },
    }
  </script>
  
<style scoped>
  .v-card-title {
    padding: 16px 16px 8px;  /* Padding around the title */
  }
</style>